export default __webpack_public_path__ + "ec2b15e71d2dcc7bf943858582c064be.png";